import React, { FC, ReactElement } from 'react'
import { Typography, Button, Modal } from 'antd'
import { useTranslation } from 'react-i18next'
import * as Sentry from '@sentry/browser'
import { s } from './style'

const { Text } = Typography

export enum ContactAmModalVariant {
  Book,
  Cancel,
}

interface ContactAmModalProps {
  variant: ContactAmModalVariant
  visible: boolean
  handleClose: () => void
}

export const ContactAmModal: FC<ContactAmModalProps> = ({
  variant,
  visible,
  handleClose,
}): ReactElement => {
  const { t } = useTranslation()

  const VariantSwitch = (): ReactElement => {
    switch (variant) {
      case ContactAmModalVariant.Book:
        return t('contactAm.modal.book', 'To book a venue, please give your account manager a call')
      case ContactAmModalVariant.Cancel:
        return t(
          'contactAm.modal.cancel',
          'If you want to cancel this event, please call your account manager'
        )
      default:
        Sentry.captureException({ message: 'ContactAmModalVariant has illegal value', variant })
        return null
    }
  }

  return (
    <Modal
      visible={visible}
      onCancel={handleClose}
      closable={false}
      footer={null}
      bodyStyle={s.body}
      width={600}>
      <img width={110} src={require('../../../../Images/telephone.svg')} />
      <Text style={s.text}>{VariantSwitch()}</Text>
      <Button onClick={handleClose} style={s.button}>
        {t('contactAm.modal.close', 'Close')}
      </Button>
    </Modal>
  )
}
